import React, { useEffect, useState } from 'react';
import Row from './Row';
import { TableCalcStyle } from './style';

export default function TableCalcsOrcam({ type, optionsArray }) {
  const [janItem1, setJanItem1] = useState(0);
  const [janItem2, setJanItem2] = useState(0);
  const [janItem3, setJanItem3] = useState(0);
  const [janItem4, setJanItem4] = useState(0);
  const [janItem5, setJanItem5] = useState(0);
  const [janItem6, setJanItem6] = useState(0);
  const [janItem7, setJanItem7] = useState(0);
  const [janItem8, setJanItem8] = useState(0);
  const [janItem9, setJanItem9] = useState(0);
  const [janItem10, setJanItem10] = useState(0);
  const [totalItensJan, setTotalItensJan] = useState(0);

  const [fevItem1, setFevItem1] = useState(0);
  const [fevItem2, setFevItem2] = useState(0);
  const [fevItem3, setFevItem3] = useState(0);
  const [fevItem4, setFevItem4] = useState(0);
  const [fevItem5, setFevItem5] = useState(0);
  const [fevItem6, setFevItem6] = useState(0);
  const [fevItem7, setFevItem7] = useState(0);
  const [fevItem8, setFevItem8] = useState(0);
  const [fevItem9, setFevItem9] = useState(0);
  const [fevItem10, setFevItem10] = useState(0);
  const [totalItensFev, setTotalItensFev] = useState(0);

  const [marItem1, setMarItem1] = useState(0);
  const [marItem2, setMarItem2] = useState(0);
  const [marItem3, setMarItem3] = useState(0);
  const [marItem4, setMarItem4] = useState(0);
  const [marItem5, setMarItem5] = useState(0);
  const [marItem6, setMarItem6] = useState(0);
  const [marItem7, setMarItem7] = useState(0);
  const [marItem8, setMarItem8] = useState(0);
  const [marItem9, setMarItem9] = useState(0);
  const [marItem10, setMarItem10] = useState(0);
  const [totalItensMar, setTotalItensMar] = useState(0);

  const [abrItem1, setAbrItem1] = useState(0);
  const [abrItem2, setAbrItem2] = useState(0);
  const [abrItem3, setAbrItem3] = useState(0);
  const [abrItem4, setAbrItem4] = useState(0);
  const [abrItem5, setAbrItem5] = useState(0);
  const [abrItem6, setAbrItem6] = useState(0);
  const [abrItem7, setAbrItem7] = useState(0);
  const [abrItem8, setAbrItem8] = useState(0);
  const [abrItem9, setAbrItem9] = useState(0);
  const [abrItem10, setAbrItem10] = useState(0);
  const [totalItensAbr, setTotalItensAbr] = useState(0);

  const [maiItem1, setMaiItem1] = useState(0);
  const [maiItem2, setMaiItem2] = useState(0);
  const [maiItem3, setMaiItem3] = useState(0);
  const [maiItem4, setMaiItem4] = useState(0);
  const [maiItem5, setMaiItem5] = useState(0);
  const [maiItem6, setMaiItem6] = useState(0);
  const [maiItem7, setMaiItem7] = useState(0);
  const [maiItem8, setMaiItem8] = useState(0);
  const [maiItem9, setMaiItem9] = useState(0);
  const [maiItem10, setMaiItem10] = useState(0);
  const [totalItensMai, setTotalItensMai] = useState(0);

  const [junItem1, setJunItem1] = useState(0);
  const [junItem2, setJunItem2] = useState(0);
  const [junItem3, setJunItem3] = useState(0);
  const [junItem4, setJunItem4] = useState(0);
  const [junItem5, setJunItem5] = useState(0);
  const [junItem6, setJunItem6] = useState(0);
  const [junItem7, setJunItem7] = useState(0);
  const [junItem8, setJunItem8] = useState(0);
  const [junItem9, setJunItem9] = useState(0);
  const [junItem10, setJunItem10] = useState(0);
  const [totalItensJun, setTotalItensJun] = useState(0);

  const [julItem1, setJulItem1] = useState(0);
  const [julItem2, setJulItem2] = useState(0);
  const [julItem3, setJulItem3] = useState(0);
  const [julItem4, setJulItem4] = useState(0);
  const [julItem5, setJulItem5] = useState(0);
  const [julItem6, setJulItem6] = useState(0);
  const [julItem7, setJulItem7] = useState(0);
  const [julItem8, setJulItem8] = useState(0);
  const [julItem9, setJulItem9] = useState(0);
  const [julItem10, setJulItem10] = useState(0);
  const [totalItensJul, setTotalItensJul] = useState(0);

  const [agoItem1, setAgoItem1] = useState(0);
  const [agoItem2, setAgoItem2] = useState(0);
  const [agoItem3, setAgoItem3] = useState(0);
  const [agoItem4, setAgoItem4] = useState(0);
  const [agoItem5, setAgoItem5] = useState(0);
  const [agoItem6, setAgoItem6] = useState(0);
  const [agoItem7, setAgoItem7] = useState(0);
  const [agoItem8, setAgoItem8] = useState(0);
  const [agoItem9, setAgoItem9] = useState(0);
  const [agoItem10, setAgoItem10] = useState(0);
  const [totalItensAgo, setTotalItensAgo] = useState(0);

  const [setItem1, setSetItem1] = useState(0);
  const [setItem2, setSetItem2] = useState(0);
  const [setItem3, setSetItem3] = useState(0);
  const [setItem4, setSetItem4] = useState(0);
  const [setItem5, setSetItem5] = useState(0);
  const [setItem6, setSetItem6] = useState(0);
  const [setItem7, setSetItem7] = useState(0);
  const [setItem8, setSetItem8] = useState(0);
  const [setItem9, setSetItem9] = useState(0);
  const [setItem10, setSetItem10] = useState(0);
  const [totalItensSet, setTotalItensSet] = useState(0);

  const [outItem1, setOutItem1] = useState(0);
  const [outItem2, setOutItem2] = useState(0);
  const [outItem3, setOutItem3] = useState(0);
  const [outItem4, setOutItem4] = useState(0);
  const [outItem5, setOutItem5] = useState(0);
  const [outItem6, setOutItem6] = useState(0);
  const [outItem7, setOutItem7] = useState(0);
  const [outItem8, setOutItem8] = useState(0);
  const [outItem9, setOutItem9] = useState(0);
  const [outItem10, setOutItem10] = useState(0);
  const [totalItensOut, setTotalItensOut] = useState(0);

  const [novItem1, setNovItem1] = useState(0);
  const [novItem2, setNovItem2] = useState(0);
  const [novItem3, setNovItem3] = useState(0);
  const [novItem4, setNovItem4] = useState(0);
  const [novItem5, setNovItem5] = useState(0);
  const [novItem6, setNovItem6] = useState(0);
  const [novItem7, setNovItem7] = useState(0);
  const [novItem8, setNovItem8] = useState(0);
  const [novItem9, setNovItem9] = useState(0);
  const [novItem10, setNovItem10] = useState(0);
  const [totalItensNov, setTotalItensNov] = useState(0);

  const [dezItem1, setDezItem1] = useState(0);
  const [dezItem2, setDezItem2] = useState(0);
  const [dezItem3, setDezItem3] = useState(0);
  const [dezItem4, setDezItem4] = useState(0);
  const [dezItem5, setDezItem5] = useState(0);
  const [dezItem6, setDezItem6] = useState(0);
  const [dezItem7, setDezItem7] = useState(0);
  const [dezItem8, setDezItem8] = useState(0);
  const [dezItem9, setDezItem9] = useState(0);
  const [dezItem10, setDezItem10] = useState(0);
  const [totalItensDez, setTotalItensDez] = useState(0);

  const [totalMonthsRow1, setTotalMonthsRow1] = useState(0);
  const [totalMonthsRow2, setTotalMonthsRow2] = useState(0);
  const [totalMonthsRow3, setTotalMonthsRow3] = useState(0);
  const [totalMonthsRow4, setTotalMonthsRow4] = useState(0);
  const [totalMonthsRow5, setTotalMonthsRow5] = useState(0);
  const [totalMonthsRow6, setTotalMonthsRow6] = useState(0);
  const [totalMonthsRow7, setTotalMonthsRow7] = useState(0);
  const [totalMonthsRow8, setTotalMonthsRow8] = useState(0);
  const [totalMonthsRow9, setTotalMonthsRow9] = useState(0);
  const [totalMonthsRow10, setTotalMonthsRow10] = useState(0);
  const [total, setTotal] = useState(0);

  const calcTotalRow = (
    itemRow1,
    itemRow2,
    itemRow3,
    itemRow4,
    itemRow5,
    itemRow6,
    itemRow7,
    itemRow8,
    itemRow9,
    itemRow10,
    itemRow11,
    itemRow12,
  ) => {
    let result =
      parseFloat(itemRow1) +
      parseFloat(itemRow2) +
      parseFloat(itemRow3) +
      parseFloat(itemRow4) +
      parseFloat(itemRow5) +
      parseFloat(itemRow6) +
      parseFloat(itemRow7) +
      parseFloat(itemRow8) +
      parseFloat(itemRow9) +
      parseFloat(itemRow10) +
      parseFloat(itemRow11) +
      parseFloat(itemRow12);
    return result;
  };

  const calcTotalColumn = (
    itemColumn1,
    itemColumn2,
    itemColumn3,
    itemColumn4,
    itemColumn5,
    itemColumn6,
    itemColumn7,
    itemColumn8,
    itemColumn9,
    itemColumn10,
  ) => {
    let result =
      parseFloat(itemColumn1) +
      parseFloat(itemColumn2) +
      parseFloat(itemColumn3) +
      parseFloat(itemColumn4) +
      parseFloat(itemColumn5) +
      parseFloat(itemColumn6) +
      parseFloat(itemColumn7) +
      parseFloat(itemColumn8) +
      parseFloat(itemColumn9) +
      parseFloat(itemColumn10);
    return result;
  };

  useEffect(() => {
    setTotalMonthsRow1(
      calcTotalRow(
        janItem1,
        fevItem1,
        marItem1,
        abrItem1,
        maiItem1,
        junItem1,
        julItem1,
        agoItem1,
        setItem1,
        outItem1,
        novItem1,
        dezItem1,
      ),
    );
    setTotalMonthsRow2(
      calcTotalRow(
        janItem2,
        fevItem2,
        marItem2,
        abrItem2,
        maiItem2,
        junItem2,
        julItem2,
        agoItem2,
        setItem2,
        outItem2,
        novItem2,
        dezItem2,
      ),
    );
    setTotalMonthsRow3(
      calcTotalRow(
        janItem3,
        fevItem3,
        marItem3,
        abrItem3,
        maiItem3,
        junItem3,
        julItem3,
        agoItem3,
        setItem3,
        outItem3,
        novItem3,
        dezItem3,
      ),
    );
    setTotalMonthsRow4(
      calcTotalRow(
        janItem4,
        fevItem4,
        marItem4,
        abrItem4,
        maiItem4,
        junItem4,
        julItem4,
        agoItem4,
        setItem4,
        outItem4,
        novItem4,
        dezItem4,
      ),
    );
    setTotalMonthsRow5(
      calcTotalRow(
        janItem5,
        fevItem5,
        marItem5,
        abrItem5,
        maiItem5,
        junItem5,
        julItem5,
        agoItem5,
        setItem5,
        outItem5,
        novItem5,
        dezItem5,
      ),
    );
    setTotalMonthsRow6(
      calcTotalRow(
        janItem6,
        fevItem6,
        marItem6,
        abrItem6,
        maiItem6,
        junItem6,
        julItem6,
        agoItem6,
        setItem6,
        outItem6,
        novItem6,
        dezItem6,
      ),
    );
    setTotalMonthsRow7(
      calcTotalRow(
        janItem7,
        fevItem7,
        marItem7,
        abrItem7,
        maiItem7,
        junItem7,
        julItem7,
        agoItem7,
        setItem7,
        outItem7,
        novItem7,
        dezItem7,
      ),
    );
    setTotalMonthsRow8(
      calcTotalRow(
        janItem8,
        fevItem8,
        marItem8,
        abrItem8,
        maiItem8,
        junItem8,
        julItem8,
        agoItem8,
        setItem8,
        outItem8,
        novItem8,
        dezItem8,
      ),
    );
    setTotalMonthsRow9(
      calcTotalRow(
        janItem9,
        fevItem9,
        marItem9,
        abrItem9,
        maiItem9,
        junItem9,
        julItem9,
        agoItem9,
        setItem9,
        outItem9,
        novItem9,
        dezItem9,
      ),
    );
    setTotalMonthsRow10(
      calcTotalRow(
        janItem10,
        fevItem10,
        marItem10,
        abrItem10,
        maiItem10,
        junItem10,
        julItem10,
        agoItem10,
        setItem10,
        outItem10,
        novItem10,
        dezItem10,
      ),
    );
    setTotalItensJan(
      calcTotalColumn(
        janItem1,
        janItem2,
        janItem3,
        janItem4,
        janItem5,
        janItem6,
        janItem7,
        janItem8,
        janItem9,
        janItem10,
      ),
    );
    setTotalItensFev(
      calcTotalColumn(
        fevItem1,
        fevItem2,
        fevItem3,
        fevItem4,
        fevItem5,
        fevItem6,
        fevItem7,
        fevItem8,
        fevItem9,
        fevItem10,
      ),
    );
    setTotalItensMar(
      calcTotalColumn(
        marItem1,
        marItem2,
        marItem3,
        marItem4,
        marItem5,
        marItem6,
        marItem7,
        marItem8,
        marItem9,
        marItem10,
      ),
    );
    setTotalItensAbr(
      calcTotalColumn(
        abrItem1,
        abrItem2,
        abrItem3,
        abrItem4,
        abrItem5,
        abrItem6,
        abrItem7,
        abrItem8,
        abrItem9,
        abrItem10,
      ),
    );
    setTotalItensMai(
      calcTotalColumn(
        maiItem1,
        maiItem2,
        maiItem3,
        maiItem4,
        maiItem5,
        maiItem6,
        maiItem7,
        maiItem8,
        maiItem9,
        maiItem10,
      ),
    );
    setTotalItensJun(
      calcTotalColumn(
        junItem1,
        junItem2,
        junItem3,
        junItem4,
        junItem5,
        junItem6,
        junItem7,
        junItem8,
        junItem9,
        junItem10,
      ),
    );
    setTotalItensJul(
      calcTotalColumn(
        julItem1,
        julItem2,
        julItem3,
        julItem4,
        julItem5,
        julItem6,
        julItem7,
        julItem8,
        julItem9,
        julItem10,
      ),
    );
    setTotalItensAgo(
      calcTotalColumn(
        agoItem1,
        agoItem2,
        agoItem3,
        agoItem4,
        agoItem5,
        agoItem6,
        agoItem7,
        agoItem8,
        agoItem9,
        agoItem10,
      ),
    );
    setTotalItensSet(
      calcTotalColumn(
        setItem1,
        setItem2,
        setItem3,
        setItem4,
        setItem5,
        setItem6,
        setItem7,
        setItem8,
        setItem9,
        setItem10,
      ),
    );
    setTotalItensOut(
      calcTotalColumn(
        outItem1,
        outItem2,
        outItem3,
        outItem4,
        outItem5,
        outItem6,
        outItem7,
        outItem8,
        outItem9,
        outItem10,
      ),
    );
    setTotalItensNov(
      calcTotalColumn(
        novItem1,
        novItem2,
        novItem3,
        novItem4,
        novItem5,
        novItem6,
        novItem7,
        novItem8,
        novItem9,
        novItem10,
      ),
    );
    setTotalItensDez(
      calcTotalColumn(
        dezItem1,
        dezItem2,
        dezItem3,
        dezItem4,
        dezItem5,
        dezItem6,
        dezItem7,
        dezItem8,
        dezItem9,
        dezItem10,
      ),
    );
    setTotal(
      calcTotalRow(
        totalItensJan,
        totalItensFev,
        totalItensMar,
        totalItensAbr,
        totalItensMai,
        totalItensJun,
        totalItensJul,
        totalItensAgo,
        totalItensSet,
        totalItensOut,
        totalItensNov,
        totalItensDez,
      ),
    );
  }, [
    janItem1,
    janItem2,
    janItem3,
    janItem4,
    janItem5,
    janItem6,
    janItem7,
    janItem8,
    janItem9,
    janItem10,
    fevItem1,
    fevItem2,
    fevItem3,
    fevItem4,
    fevItem5,
    fevItem6,
    fevItem7,
    fevItem8,
    fevItem9,
    fevItem10,
    marItem1,
    marItem2,
    marItem3,
    marItem4,
    marItem5,
    marItem6,
    marItem7,
    marItem8,
    marItem9,
    marItem10,
    abrItem1,
    abrItem2,
    abrItem3,
    abrItem4,
    abrItem5,
    abrItem6,
    abrItem7,
    abrItem8,
    abrItem9,
    abrItem10,
    maiItem1,
    maiItem2,
    maiItem3,
    maiItem4,
    maiItem5,
    maiItem6,
    maiItem7,
    maiItem8,
    maiItem9,
    maiItem10,
    junItem1,
    junItem2,
    junItem3,
    junItem4,
    junItem5,
    junItem6,
    junItem7,
    junItem8,
    junItem9,
    junItem10,
    julItem1,
    julItem2,
    julItem3,
    julItem4,
    julItem5,
    julItem6,
    julItem7,
    julItem8,
    julItem9,
    julItem10,
    agoItem1,
    agoItem2,
    agoItem3,
    agoItem4,
    agoItem5,
    agoItem6,
    agoItem7,
    agoItem8,
    agoItem9,
    agoItem10,
    setItem1,
    setItem2,
    setItem3,
    setItem4,
    setItem5,
    setItem6,
    setItem7,
    setItem8,
    setItem9,
    setItem10,
    outItem1,
    outItem2,
    outItem3,
    outItem4,
    outItem5,
    outItem6,
    outItem7,
    outItem8,
    outItem9,
    outItem10,
    novItem1,
    novItem2,
    novItem3,
    novItem4,
    novItem5,
    novItem6,
    novItem7,
    novItem8,
    novItem9,
    novItem10,
    dezItem1,
    dezItem2,
    dezItem3,
    dezItem4,
    dezItem5,
    dezItem6,
    dezItem7,
    dezItem8,
    dezItem9,
    dezItem10,
    totalItensJan,
    totalItensFev,
    totalItensMar,
    totalItensAbr,
    totalItensMai,
    totalItensJun,
    totalItensJul,
    totalItensAgo,
    totalItensSet,
    totalItensOut,
    totalItensNov,
    totalItensDez,
  ]);

  return (
    <TableCalcStyle>
      <table>
        <thead>
          <tr>
            <th>{type}</th>
            <th>JAN</th>
            <th>FEV</th>
            <th>MAR</th>
            <th>ABR</th>
            <th>MAI</th>
            <th>JUN</th>
            <th>JUL</th>
            <th>AGO</th>
            <th>SET</th>
            <th>OUT</th>
            <th>NOV</th>
            <th>DEZ</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <Row
            setJanItem={setJanItem1}
            setFevItem={setFevItem1}
            setMarItem={setMarItem1}
            setAbrItem={setAbrItem1}
            setMaiItem={setMaiItem1}
            setJunItem={setJunItem1}
            setJulItem={setJulItem1}
            setAgoItem={setAgoItem1}
            setSetItem={setSetItem1}
            setOutItem={setOutItem1}
            setNovItem={setNovItem1}
            setDezItem={setDezItem1}
            totalMonthsRow={totalMonthsRow1}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem2}
            setFevItem={setFevItem2}
            setMarItem={setMarItem2}
            setAbrItem={setAbrItem2}
            setMaiItem={setMaiItem2}
            setJunItem={setJunItem2}
            setJulItem={setJulItem2}
            setAgoItem={setAgoItem2}
            setSetItem={setSetItem2}
            setOutItem={setOutItem2}
            setNovItem={setNovItem2}
            setDezItem={setDezItem2}
            totalMonthsRow={totalMonthsRow2}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem3}
            setFevItem={setFevItem3}
            setMarItem={setMarItem3}
            setAbrItem={setAbrItem3}
            setMaiItem={setMaiItem3}
            setJunItem={setJunItem3}
            setJulItem={setJulItem3}
            setAgoItem={setAgoItem3}
            setSetItem={setSetItem3}
            setOutItem={setOutItem3}
            setNovItem={setNovItem3}
            setDezItem={setDezItem3}
            totalMonthsRow={totalMonthsRow3}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem4}
            setFevItem={setFevItem4}
            setMarItem={setMarItem4}
            setAbrItem={setAbrItem4}
            setMaiItem={setMaiItem4}
            setJunItem={setJunItem4}
            setJulItem={setJulItem4}
            setAgoItem={setAgoItem4}
            setSetItem={setSetItem4}
            setOutItem={setOutItem4}
            setNovItem={setNovItem4}
            setDezItem={setDezItem4}
            totalMonthsRow={totalMonthsRow4}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem5}
            setFevItem={setFevItem5}
            setMarItem={setMarItem5}
            setAbrItem={setAbrItem5}
            setMaiItem={setMaiItem5}
            setJunItem={setJunItem5}
            setJulItem={setJulItem5}
            setAgoItem={setAgoItem5}
            setSetItem={setSetItem5}
            setOutItem={setOutItem5}
            setNovItem={setNovItem5}
            setDezItem={setDezItem5}
            totalMonthsRow={totalMonthsRow5}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem6}
            setFevItem={setFevItem6}
            setMarItem={setMarItem6}
            setAbrItem={setAbrItem6}
            setMaiItem={setMaiItem6}
            setJunItem={setJunItem6}
            setJulItem={setJulItem6}
            setAgoItem={setAgoItem6}
            setSetItem={setSetItem6}
            setOutItem={setOutItem6}
            setNovItem={setNovItem6}
            setDezItem={setDezItem6}
            totalMonthsRow={totalMonthsRow6}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem7}
            setFevItem={setFevItem7}
            setMarItem={setMarItem7}
            setAbrItem={setAbrItem7}
            setMaiItem={setMaiItem7}
            setJunItem={setJunItem7}
            setJulItem={setJulItem7}
            setAgoItem={setAgoItem7}
            setSetItem={setSetItem7}
            setOutItem={setOutItem7}
            setNovItem={setNovItem7}
            setDezItem={setDezItem7}
            totalMonthsRow={totalMonthsRow7}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem8}
            setFevItem={setFevItem8}
            setMarItem={setMarItem8}
            setAbrItem={setAbrItem8}
            setMaiItem={setMaiItem8}
            setJunItem={setJunItem8}
            setJulItem={setJulItem8}
            setAgoItem={setAgoItem8}
            setSetItem={setSetItem8}
            setOutItem={setOutItem8}
            setNovItem={setNovItem8}
            setDezItem={setDezItem8}
            totalMonthsRow={totalMonthsRow8}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem9}
            setFevItem={setFevItem9}
            setMarItem={setMarItem9}
            setAbrItem={setAbrItem9}
            setMaiItem={setMaiItem9}
            setJunItem={setJunItem9}
            setJulItem={setJulItem9}
            setAgoItem={setAgoItem9}
            setSetItem={setSetItem9}
            setOutItem={setOutItem9}
            setNovItem={setNovItem9}
            setDezItem={setDezItem9}
            totalMonthsRow={totalMonthsRow9}
            optionsArray={optionsArray}
          />
          <Row
            setJanItem={setJanItem10}
            setFevItem={setFevItem10}
            setMarItem={setMarItem10}
            setAbrItem={setAbrItem10}
            setMaiItem={setMaiItem10}
            setJunItem={setJunItem10}
            setJulItem={setJulItem10}
            setAgoItem={setAgoItem10}
            setSetItem={setSetItem10}
            setOutItem={setOutItem10}
            setNovItem={setNovItem10}
            setDezItem={setDezItem10}
            totalMonthsRow={totalMonthsRow10}
            optionsArray={optionsArray}
          />
        </tbody>
        <tfoot>
          <tr>
            <td>Total:</td>
            <td>
              <p>{totalItensJan.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensFev.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensMar.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensAbr.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensMai.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensJun.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensJul.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensAgo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensSet.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensOut.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensNov.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalItensDez.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
        </tfoot>
      </table>
    </TableCalcStyle>
  );
}
